// @flow
import { createContext } from 'react';
import type { Context } from 'react';

type ElementContextType = {
  activeElement: any,
  pathname: string,
  unixTimestamp?: any,
  toggleNavBar: Function,
  mounted?: boolean,
};

export const ElementContext: Context<ElementContextType> = createContext({
  activeElement: null,
  pathname: '/',
  toggleNavBar: () => null,
});
